/*! @azure/msal-common v16.4.1 2026-04-01 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.4.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
